var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"donghua"},[_c('div',{staticClass:"demo1"}),_c('div',{staticClass:"demo1"}),_c('div',{staticClass:"demo1"}),_c('div',{staticClass:"demo1"}),_c('div',{staticClass:"demo1"})])]),_c('div',{staticClass:"overlay"})])
}]

export { render, staticRenderFns }